import { Pipe, PipeTransform } from '@angular/core';
import { WorkTimerecordtypeNameEnum } from '@work-frontend-monorepo/work-rest-api';

@Pipe({
  name: 'getTimerecordtypeIconName',
  standalone: true,
})
export class GetTimerecordtypeIconNamePipe implements PipeTransform {
  transform(timerecordtypeName: WorkTimerecordtypeNameEnum | null | undefined): string {
    switch (timerecordtypeName) {
      case WorkTimerecordtypeNameEnum.Arbeit: {
        return 'engineering';
      }
      case WorkTimerecordtypeNameEnum.Ferien: {
        return 'beach_access';
      }
      case WorkTimerecordtypeNameEnum.MilitarZivilschutz: {
        return 'military_tech';
      }
      case WorkTimerecordtypeNameEnum.BezahlteAbsenz: {
        return 'arrow_outward';
      }
      case WorkTimerecordtypeNameEnum.Kompensation: {
        return 'remove';
      }
      case WorkTimerecordtypeNameEnum.Krank: {
        return 'medication';
      }
      case WorkTimerecordtypeNameEnum.Unfall: {
        return 'ambulance';
      }
      case WorkTimerecordtypeNameEnum.Feiertag: {
        return 'mood';
      }
      case WorkTimerecordtypeNameEnum.Frei: {
        return 'close';
      }
      case WorkTimerecordtypeNameEnum.SchuleWeiterbildung: {
        return 'school';
      }
      default: {
        return 'help';
      }
    }
  }
}
